import React, {useEffect, useState} from "react";
import DashboardHeader from "./dashboard_header";
import SideMenu from "./dashboard_menu";
import DashboardFooter from "./dashboard_footer";
import axios from "axios";
import localforage from "localforage";
import Swal from "sweetalert2";
import {useBaseUrl} from "../../utils/utils";
import Canvas from "./dahboard_canvas";
import set = Reflect.set;

interface counties  {
    county: string,
    county_code: number
}

interface services {
    service_title: string,
    service_id: number
}


const SearchServices: React.FC = () => {
    useEffect(()=>{
        //getAllServices();
        //getAllCounties(countyId);

        document.title = "Uzima Create Public Request";

    }, [])

    const base_url = useBaseUrl();

    const [townReady, setTownReady] = useState<boolean>(true);
    const [countyId, setCountyId] = useState<number>(47);
    const [townId, setTownId] = useState<number>();
    const [categoryId, setCategoryId] = useState<number>(99999999);
    const [towns, setTowns] = useState<any []>([]);
    const [town, setTown] = useState<any>(null);
    const [counties, setCounties] = useState<any []>([]);
    const [county, setCounty] = useState<any []>([]);
    const [categories, setCategories] = useState<any []>([]);
    const [applicationId, setApplicationId] = useState();
    const [serviceId, setServiceId] = useState();
    const [jobs, setJobs] = useState<any []>([]);
    const [job, setJob] = useState();
    const [jobCount, setJobCount] = useState<number>(0);
    const [page, setPage] = useState("")
    const [selectedJob, setSelectedJob] = useState<any>()
    const [step, setStep] = useState(0)

    const staff_id = localforage.getItem("staff_id");
    const institution_id = localforage.getItem("institution_id");
    const clinic_id = localforage.getItem("clinic_id");



    const getAllTowns = async (town_id= townId) => {

        let town_url = base_url + "/facilities/get-towns";

        try{

            const response: any = await axios.post(town_url, {
                town_id: town_id,
                county_id: countyId,
                clinic_id: clinic_id,
                staff_id: staff_id,
                institution_id: institution_id
            });

            const {status, message, data} = response.data;

            if(response === "undefined" || response === undefined){

                await Swal.fire({
                    icon: "warning",
                    title: "Unable to connect",
                    text: "A network error occurred. Please check your connection and try again"
                })

            }

            if(status === "success"){
                if(Object.keys(data).length >= 1){

                    setTowns(data);

                    setTownReady(false);

                } else {

                    setTownReady(true)

                    await Swal.fire({
                        title: "Warning",
                        icon: "warning",
                        text: "The server returned zero(0) towns. Filter by towns will be unavailable"
                    })
                }
            }else if(status == "error"){

                await Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: message
                });
            }


        }catch (e) {

            await Swal.fire({
                icon: "warning",
                title: "Towns",
                text: "Unable to fetch towns. Filter by towns will be unavailable"
            })

            return

        }
    }

    const getAllCounties = async (county_id = countyId) => {

        let county_url = base_url + "/facilities/get-counties";

        try{

            const response = await axios.post(county_url, {
                county_id: countyId,
                clinic_id: clinic_id,
                staff_id: staff_id,
                institution_id: institution_id
            });

            const {status, message, data} = response.data;

            if(status == "success"){
                if(Object.keys(data).length == 1){

                    const response_data: counties[] = data

                    setCounty(response_data);

                    setTownReady(false)

                }else if(Object.keys(data).length > 1){

                    const response_data: counties[] = data

                    setCounties(response_data);

                    setTownReady(false);

                } else {
                    setTownReady(true)

                    await Swal.fire({
                        title: "Warning",
                        icon: "warning",
                        text: "The server returned zero(0) counties. Filter by location will be unavailable"
                    })
                }
            }else if(status == "error"){
                setTownReady(true)
                await Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: message
                });
            }


        }catch (e) {
            setTownReady(true)

            await Swal.fire({
                icon: "warning",
                title: "Towns",
                text: "Unable to fetch counties. Filter by towns will be unavailable"
            })

        }

    }

    const getAllServices = async ()=>{

        try{

            const response = await axios.get(base_url + '/facilities/service-list');

            const {status, message, data} = response.data;

            if(status === "success"){

                const sorted_data: services [] = data;

                setCategories(sorted_data);

            }else{
                await Swal.fire({
                    icon: "error",
                    title:"Error",
                    text: message
                });

                return;
            }

        }catch (e) {

            await Swal.fire({
                icon: "error",
                title: "Error",
                text: "Server communication failure. Check your connection and try again."
            })

            return;

        }

    }

    const getServices = ()=>{
        let retries = 0;
        const maxRetries = 3;
        const delay = 3000;

        let service_url = base_url + "/collaborations/jobs";

        const runTrySegment = async ()=>{

            try{

                const response = await axios.post(service_url, {
                    town_id: townId,
                    county_code: countyId,
                    application_id: applicationId,
                    service_id: serviceId
                });

                const {status, message, data} = response.data;

                if(status === "success"){

                    if(Object.keys(data).length==0){
                        await Swal.fire({
                            icon: "success",
                            text: "The query was successful but got no results. Expand your search parameters perhaps?",
                            title: "Zero results"
                        })

                        setJobCount(0)
                    }else if(Object.keys(data).length==1){

                        setJob(data);

                        setJobCount(Object.keys(data).length)

                    }else{
                        setJobs(data)

                        setJobCount(Object.keys(data).length)
                    }

                }else{

                    await Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: message
                    })
                }

            }catch (error) {

                if (retries < maxRetries) {
                    retries++;

                    await Swal.fire({
                        icon: "info",
                        title: "Retry",
                        text: `Server unreachable. Retrying (${retries}/${maxRetries}) in ${delay / 2000} seconds...`
                    })

                    setTimeout(runTrySegment, delay);
                } else {
                    await Swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text: `Exceeded maximum attempts (${maxRetries}). Unable to continue, please reload this page manually.`
                    })
                }

            }

        };

        runTrySegment();

    }

    useEffect(()=> {
        if(countyId !=0){
            //getAllTowns();
        }

        //getServices();

    }, [countyId, townId, applicationId, serviceId, categoryId]);
    return(
        <>
            <DashboardHeader />
            <SideMenu />
            <div className={"vertical-overlay"} />
            <div className={"main-content"}>
                <div className={"page-content"}>
                    <div className={"container-fluid"}>
                        <div className="row">
                            <div className="col-12">
                                <div
                                    className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">Received Service Requests</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a
                                                href={"/institution/services"}>General Requests</a></li>
                                            <li className="breadcrumb-item active">Loading</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {step === 0 && (
                            <>
                                <div className="card">
                                    <div className="card-header border-0 rounded">
                                        <div className="row g-2">
                                            <div className="col-xl-3">
                                                <div className="search-box">
                                                    <input type="text" className="form-control search" placeholder="Type something" />
                                                    <i className="ri-search-line search-icon"> </i>
                                                </div>
                                            </div>

                                            <div className={"col ms-auto"}>
                                                <div>
                                                    <select className="form-control" value={categoryId} onChange={(e: any)=>{const selectedCat = e.currentTarget.value; setCategoryId(selectedCat)}}>

                                                        <option value={"99999999"}>All</option>
                                                        {
                                                            Object.values(categories).map((item)=>(
                                                                <option key={item.service_id}>{item.service_title}</option>
                                                            ))
                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                            <div className={"col ms-auto"}>
                                                <select className="form-control" value={countyId}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                            const selectedCountyId = parseInt(e.currentTarget.value);
                                                            setCountyId(selectedCountyId);

                                                        }}
                                                >
                                                    <option >Select County</option>
                                                    {
                                                        Object.values(counties).map((item) => (
                                                            <option  value={item.county_code}>{item.county} County </option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            <div className={"col ms-auto"}>

                                                <select className="form-control" disabled={townReady} onChange={(e: React.ChangeEvent<HTMLSelectElement>)=>{
                                                    const selectedTown = parseInt(e.currentTarget.value);
                                                    setTownId(selectedTown)
                                                }}>
                                                    <option >Town</option>
                                                    {Object.keys(towns).length > 1 &&
                                                    (Object.values(towns).map((item) => (
                                                        <option value={item.id} > {item.town} Town</option>
                                                    )))
                                                    }
                                                    { town === 1 &&
                                                    <option value={town.town_id}> {town.town}</option>
                                                    }
                                                    {
                                                        <option>Choose Town</option>
                                                    }
                                                </select>
                                            </div>

                                            <div className="col-lg-auto">
                                                <div className="hstack gap-2">
                                                    <button type="button" className="btn btn-danger"><i className="ri-equalizer-fill me-1 align-bottom"> </i> Filters </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={"row mt-4"}>

                                    <div className={"col-md-3"}>
                                        <div className={"card ribbon-box right overflow-hidden card-body"}>
                                            <div className={"ribbon ribbon-warning ribbon-shape trending-ribbon"}>

                                                <i className={"ri-flashlight-fill text-white align-bottom"}> </i>
                                                <span className={"trending-ribbon-text"}>Priority Request</span></div>
                                            <div className={"d-flex mb-4 align-items-center"}>
                                                <div className={"flex-shrink-0"}>
                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/companies/img-1.png`} alt="" className={"avatar-sm rounded-circle"} />
                                                </div>
                                                <div className={"flex-grow-1 ms-2"}>
                                                    <h5 className={"card-title mb-1"}>Partner X</h5>
                                                    <p className={"text-muted mb-0"}>Dentist</p>
                                                </div>
                                            </div>
                                            <h6 className={"mb-1 text-primary"}>Engagement Type: Long Term</h6>
                                            <p className={"card-text text-muted"}>We need a long term partner to collaborate with on...</p>
                                            <button className={"btn btn-primary btn-sm"} onClick={(e)=>{
                                                setStep(1)
                                            }}>Open Request</button>
                                        </div>
                                    </div>

                                </div>
                            </>
                        )}

                        {step === 1 && (

                            <div className={"row mt-4"}>
                                <div className={"col-md-3"}>



                                </div>


                                <div className={"col-md-6"}>

                                    <div className={"row mt-4"}>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{
                                                setStep(2)
                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/details.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Description Type</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/engagement.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Engagement Type</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/response.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Response Time</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/services.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Services Involved</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/framework.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Framework</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/contracts.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Contracts</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/supply.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Apply</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/summary.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Request Summary</h5>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={"col-md-4"}>

                                            <div className={"card card-animate"} onClick={()=>{

                                            }}>

                                                <div className={"card-body p-4 text-center"}>

                                                    <br />
                                                    <br />

                                                    <div onClick={(e)=>{
                                                        setStep(0)
                                                    }} className={"mx-auto avatar-md mb-3"}>

                                                        <img alt={""} className={"img-fluid "} src={`${process.env.PUBLIC_URL}/assets/images/back.png`} />


                                                    </div>

                                                    <br />
                                                    <h5 className={"card-title mb-1"}>Go Back</h5>

                                                </div>

                                            </div>

                                        </div>

                                    </div>


                                </div>

                                <div className={"col-md-3"}>

                                </div>
                            </div>

                        )}

                        {step ===2 && (

                            <>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card mt-n4 mx-n4 mb-n5">
                                            <div className="bg-soft-primary">
                                                <div className="card-body pb-4 mb-5">
                                                    <div className="row">
                                                        <div className="col-md">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-auto">
                                                                    <div className="avatar-md mb-md-0 mb-4">
                                                                        <div
                                                                            className="avatar-title bg-white rounded-circle">
                                                                            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/img-4.png`}
                                                                                 alt="" className="avatar-sm"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md">
                                                                    <h4 className="fw-semibold"
                                                                        id="ticket-title">#UZM-135 - Create an Is Lorem
                                                                        Ipsum Bot Generated Text</h4>
                                                                    <div className="hstack gap-3 flex-wrap">
                                                                        <div className="text-muted"><i
                                                                            className="ri-building-line align-bottom me-1"></i><span
                                                                            id="ticket-client">Uzima</span></div>
                                                                        <div className="vr"> </div>
                                                                        <div className="text-muted">Create Date : <span
                                                                            className="fw-medium " id="create-date">20 Dec, 2024</span>
                                                                        </div>
                                                                        <div className="vr"></div>
                                                                        <div className="text-muted">Due Date : <span
                                                                            className="fw-medium" id="due-date">29 Dec, 2024</span>
                                                                        </div>
                                                                        <div className="vr"></div>
                                                                        <div
                                                                            className="badge rounded-pill bg-info fs-12"
                                                                            id="ticket-status">New
                                                                        </div>
                                                                        <div
                                                                            className="badge rounded-pill bg-danger fs-12"
                                                                            id="ticket-priority" onClick={(e)=>{
                                                                                setStep(1)
                                                                        }}>Close Service Request
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div className="col-md-auto mt-md-0 mt-4">
                                                            <div className="hstack gap-1 flex-wrap">
                                                                <button type="button"
                                                                        className="btn avatar-xs mt-n1 p-0 favourite-btn active">
                                                        <span className="avatar-title bg-transparent fs-15">
                                                            <i className="ri-star-fill"></i>
                                                        </span>
                                                                </button>
                                                                <button type="button"
                                                                        className="btn py-0 fs-16 text-body"
                                                                        id="settingDropdown" data-bs-toggle="dropdown">
                                                                    <i className="ri-share-line"></i>
                                                                </button>
                                                                <ul className="dropdown-menu"
                                                                    aria-labelledby="settingDropdown">
                                                                    <li><a className="dropdown-item" href="#"><i
                                                                        className="ri-eye-fill align-bottom me-2 text-muted"></i> View</a>
                                                                    </li>
                                                                    <li><a className="dropdown-item" href="#"><i
                                                                        className="ri-share-forward-fill align-bottom me-2 text-muted"></i> Share
                                                                        with</a></li>
                                                                    <li><a className="dropdown-item" href="#"><i
                                                                        className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a>
                                                                    </li>
                                                                </ul>
                                                                <button type="button"
                                                                        className="btn py-0 fs-16 text-body">
                                                                    <i className="ri-flag-line"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xxl-9">
                                        <div className="card">
                                            <div className="card-body p-4">
                                                <h6 className="text-uppercase mb-3">Service Description</h6>
                                                <p className="text-muted">It is crucial to identify and address errors in patient records, such as mismatched diagnostic codes or missing appointment details. These issues may stem from system configurations or improperly applied templates in electronic medical records (EMRs). Too much clutter or poorly spaced information, like in the example below, can lead to inefficiencies and miscommunication among healthcare providers. The primary goal is to ensure that all documentation is clear and easy to comprehend for both clinicians and administrative staff. Regarding consistency, maintaining a standardized approach to patient forms and data entry is essential. Using a unified color scheme and layout across EMR interfaces fosters usability and improves staff efficiency. Subtle but thoughtful interface improvements can enhance user interaction while minimizing errors. <a href="javascript:void(0);" className="link-secondary text-decoration-underline">View Example</a>
                                                </p>
                                                <h6 className="text-uppercase mb-3">Service scope</h6>
                                                <ul className="text-muted vstack gap-2 mb-4">
                                                    <li>Pick a Dashboard Type</li>
                                                    <li>Categorize information when needed</li>
                                                    <li>Provide Context</li>
                                                    <li>On using colors</li>
                                                    <li>On using the right graphs</li>
                                                </ul>
                                                <div className="mt-4">
                                                    <h6 className="text-uppercase mb-3">Here is the service you've requested</h6>
                                                    <div>
                                        <pre className="language-markup rounded-2">
                                            <p>

                                                medication info from uzima

                                            </p>
                                        </pre>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body p-4">
                                                <h5 className="card-title mb-4">Comments</h5>

                                                <div data-simplebar style={{"height": "300px"}} className="px-3 mx-n3">
                                                    <div className="d-flex mb-4">
                                                        <div className="flex-shrink-0">
                                                            <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-8.jpg`} alt=""
                                                                 className="avatar-xs rounded-circle"/>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h5 className="fs-13">BOT Parker <small
                                                                className="text-muted">20 Dec 2024 - 05:47AM</small>
                                                            </h5>
                                                            <p className="text-muted">I am getting message from
                                                                customers that when they place order always get error
                                                                message .</p>
                                                            <a href="javascript: void(0);"
                                                               className="badge text-muted bg-light"><i
                                                                className="mdi mdi-reply"></i> Reply</a>
                                                            <div className="d-flex mt-4">
                                                                <div className="flex-shrink-0">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-10.jpg`} alt=""
                                                                         className="avatar-xs rounded-circle"/>
                                                                </div>
                                                                <div className="flex-grow-1 ms-3">
                                                                    <h5 className="fs-13">BOT Clarke <small
                                                                        className="text-muted">22 Dec 2024 -
                                                                        02:32PM</small></h5>
                                                                    <p className="text-muted">Please be sure to check
                                                                        your Spam mailbox to see if your email filters
                                                                        have identified the email from Dell as spam.</p>
                                                                    <a href="javascript: void(0);"
                                                                       className="badge text-muted bg-light"><i
                                                                        className="mdi mdi-reply"></i> Reply</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex mb-4">
                                                        <div className="flex-shrink-0">
                                                            <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-6.jpg`} alt=""
                                                                 className="avatar-xs rounded-circle"/>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h5 className="fs-13">Donald Palmer <small
                                                                className="text-muted">24 Dec 2024 - 05:20PM</small>
                                                            </h5>
                                                            <p className="text-muted">If you have further questions,
                                                                please contact Customer Support from the “Action Menu”
                                                                on your <a href="javascript:void(0);"
                                                                           className="text-decoration-underline">Online
                                                                    Order Support</a>.</p>
                                                            <a href="javascript: void(0);"
                                                               className="badge text-muted bg-light"><i
                                                                className="mdi mdi-reply"></i> Reply</a>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-10.jpg`} alt=""
                                                                 className="avatar-xs rounded-circle"/>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h5 className="fs-13">Alexis Clarke <small
                                                                className="text-muted">26 min ago</small></h5>
                                                            <p className="text-muted">Your <a href="javascript:void(0)"
                                                                                              className="text-decoration-underline">Online
                                                                Order Support</a> provides you with the most current
                                                                status of your order. To help manage your order refer to
                                                                the “Action Menu” to initiate return, contact Customer
                                                                Support and more.</p>
                                                            <div className="row g-2 mb-3">
                                                                <div className="col-lg-1 col-sm-2 col-6">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/small/img-4.jpg`} alt=""
                                                                         className="img-fluid rounded" />
                                                                </div>
                                                                <div className="col-lg-1 col-sm-2 col-6">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/small/img-5.jpg`} alt=""
                                                                         className="img-fluid rounded" />
                                                                </div>
                                                            </div>
                                                            <a href="javascript: void(0);"
                                                               className="badge text-muted bg-light"><i
                                                                className="mdi mdi-reply"> </i> Reply</a>
                                                            <div className="d-flex mt-4">
                                                                <div className="flex-shrink-0">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-6.jpg`} alt=""
                                                                         className="avatar-xs rounded-circle"/>
                                                                </div>
                                                                <div className="flex-grow-1 ms-3">
                                                                    <h5 className="fs-13">Donald Palmer <small
                                                                        className="text-muted">8 sec ago</small></h5>
                                                                    <p className="text-muted">Other shipping methods are
                                                                        available at checkout if you want your purchase
                                                                        delivered faster.</p>
                                                                    <a href="javascript: void(0);"
                                                                       className="badge text-muted bg-light"> <i
                                                                        className="mdi mdi-reply"> </i> Reply</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <form action="javascript:void(0);" className="mt-3">
                                                    <div className="row g-3">
                                                        <div className="col-lg-12">
                                                            <label htmlFor="exampleFormControlTextarea1"
                                                                   className="form-label">Leave a Comments</label>
                                                            <textarea className="form-control bg-light border-light"
                                                                      id="exampleFormControlTextarea1" rows= {3}
                                                                      placeholder="Enter comments"> </textarea>
                                                        </div>
                                                        <div className="col-lg-12 text-end">
                                                            <a href="javascript:void(0);" className="btn btn-success">Post
                                                                Comments</a>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="col-xxl-3">
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title mb-0">Service Details</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive table-card">
                                                    <table className="table table-borderless align-middle mb-0">
                                                        <tbody>
                                                        <tr>
                                                            <td className="fw-medium">service ID</td>
                                                            <td>#UZM-<span id="t-no">UZM9876</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Client</td>
                                                            <td id="t-client">Pugachev Clinic</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Service Request</td>
                                                            <td>Dental Extraction 101</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Assigned To:</td>
                                                            <td>
                                                                <div className="avatar-group">
                                                                    <a href="javascript:void(0);"
                                                                       className="avatar-group-item"
                                                                       data-bs-toggle="tooltip" data-bs-placement="top"
                                                                       data-bs-trigger="hover"
                                                                       data-bs-original-title="BOT Kernan">
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-4.jpg`}
                                                                             alt=""
                                                                             className="rounded-circle avatar-xs"/>
                                                                    </a>
                                                                    <a href="javascript:void(0);"
                                                                       className="avatar-group-item"
                                                                       data-bs-toggle="tooltip" data-bs-placement="top"
                                                                       data-bs-trigger="hover"
                                                                       data-bs-original-title="BOT Clarke">
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-10.jpg`}
                                                                             alt=""
                                                                             className="rounded-circle avatar-xs"/>
                                                                    </a>
                                                                    <a href="javascript:void(0);"
                                                                       className="avatar-group-item"
                                                                       data-bs-toggle="tooltip" data-bs-placement="top"
                                                                       data-bs-trigger="hover"
                                                                       data-bs-original-title="BOT Price">
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/users/avatar-3.jpg`}
                                                                             alt=""
                                                                             className="rounded-circle avatar-xs"/>
                                                                    </a>
                                                                    <a href="javascript: void(0);"
                                                                       className="avatar-group-item"
                                                                       data-bs-toggle="tooltip" data-bs-trigger="hover"
                                                                       data-bs-placement="top"
                                                                       data-bs-original-title="BOT Members">
                                                                        <div className="avatar-xs">
                                                                            <div
                                                                                className="avatar-title fs-16 rounded-circle bg-light border-dashed border text-primary">
                                                                                +
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Status:</td>
                                                            <td>
                                                                <select className="form-select" id="t-status"
                                                                        aria-label="Default select example">
                                                                    <option>Stauts</option>
                                                                    <option value="New" selected>New</option>
                                                                    <option value="Open">Open</option>
                                                                    <option value="Inprogress">Inprogress</option>
                                                                    <option value="Closed">Closed</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Priority</td>
                                                            <td>
                                                                <span className="badge bg-danger"
                                                                      id="t-priority">High</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Create Date</td>
                                                            <td id="c-date">20 Dec, 2024</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Due Date</td>
                                                            <td id="d-date">29 Dec, 2024</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Last Activity</td>
                                                            <td>14 min ago</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Labels</td>
                                                            <td className="hstack text-wrap gap-1">
                                                                <span className="badge badge-soft-primary">Admin</span>
                                                                <span className="badge badge-soft-primary">UI</span>
                                                                <span
                                                                    className="badge badge-soft-primary">Dashboard</span>
                                                                <span className="badge badge-soft-primary">Design</span>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <h6 className="card-title fw-semibold mb-0">Shared Files</h6>
                                            </div>
                                            <div className="card-body">
                                                <div
                                                    className="d-flex align-items-center border border-dashed p-2 rounded">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <div className="avatar-title bg-light rounded">
                                                            <i className="ri-file-zip-line fs-20 text-primary"></i>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1"><a href="javascript:void(0);"
                                                                                className="text-body">Recorded Issues.zip</a>
                                                        </h6>
                                                        <small className="text-muted">3.2 MB</small>
                                                    </div>
                                                    <div className="hstack gap-3 fs-16">
                                                        <a href="javascript:void(0);" className="text-muted"><i
                                                            className="ri-download-2-line"></i></a>
                                                        <a href="javascript:void(0);" className="text-muted"><i
                                                            className="ri-delete-bin-line"></i></a>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-flex  align-items-center border border-dashed p-2 rounded mt-2">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <div className="avatar-title bg-light rounded">
                                                            <i className="ri-file-ppt-2-line fs-20 text-danger"></i>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1"><a href="javascript:void(0);"
                                                                                className="text-body">Service Requirements.ppt</a>
                                                        </h6>
                                                        <small className="text-muted">4.5 MB</small>
                                                    </div>
                                                    <div className="hstack gap-3 fs-16">
                                                        <a href="javascript:void(0);" className="text-muted"><i
                                                            className="ri-download-2-line"></i></a>
                                                        <a href="javascript:void(0);" className="text-muted"><i
                                                            className="ri-delete-bin-line"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>

                        )}


                    </div>
                </div>
                <Canvas />
            </div>
            <DashboardFooter />
        </>
    )
}

export default SearchServices;